/**
 * Shared gender type options and helpers.
 * - Customer forms/grids use id-based: getGenderType(), getGenderTypeData(row), valueExpr: 'id'
 * - User/Teacher forms/grids use boolean|null: getGenderTypeForAccount(), getGenderTypeDataForAccount(row), valueExpr: 'value'
 */
let GenderTypeService = {}

// Customer (id: 0 = empty, 1 = Male, 2 = Female)
GenderTypeService.setGenderTypeList = [
    { id: 0, genderType: '' },
    { id: 1, genderType: 'Male' },
    { id: 2, genderType: 'Female' },
]

GenderTypeService.getGenderType = () => {
    return GenderTypeService.setGenderTypeList
}

GenderTypeService.getGenderTypeData = (row) => {
    const item = GenderTypeService.setGenderTypeList.find((i) => i.id === row.genderType)
    return item ? item.genderType : ''
}

// User/Teacher accounts (value: null | false | true for API; display 'Prefer not to say' | 'Male' | 'Female')
GenderTypeService.setGenderTypeListForAccount = [
    { value: null, genderType: 'Prefer not to say' },
    { value: false, genderType: 'Male' },
    { value: true, genderType: 'Female' },
]

GenderTypeService.getGenderTypeForAccount = () => {
    return GenderTypeService.setGenderTypeListForAccount
}

GenderTypeService.getGenderTypeDataForAccount = (row) => {
    const val = row?.genderType !== undefined ? row.genderType : row?.GenderType
    const item = GenderTypeService.setGenderTypeListForAccount.find((i) => i.value === val)
    return item ? item.genderType : '—'
}

export default GenderTypeService
